import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';

function getBarColor(score) {
  if (score >= 0.8) return '#22c55e'; // green-500
  if (score >= 0.6) return '#eab308'; // yellow-500
  return '#ef4444'; // red-500
}

export default function ConfidenceChart({ chunks }) {
  const data = chunks.map((chunk, idx) => ({
    name: `Chunk ${idx + 1}`,
    score: Math.round(chunk.score * 100),
    fill: getBarColor(chunk.score)
  }));

  return (
    <div className="h-[200px]" data-testid="confidence-chart-container">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical" margin={{ top: 5, right: 30, left: 60, bottom: 5 }}>
          <XAxis type="number" domain={[0, 100]} tickFormatter={(v) => `${v}%`} />
          <YAxis type="category" dataKey="name" tick={{ fontSize: 12 }} />
          <Tooltip 
            formatter={(value) => [`${value}%`, 'Score']}
            contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e5e5',
              borderRadius: '4px',
              fontSize: '12px'
            }}
          />
          <Bar dataKey="score" radius={[0, 4, 4, 0]}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      
      {/* Legend */}
      <div className="flex items-center justify-center gap-4 mt-2 text-xs text-muted-foreground">
        <span className="flex items-center gap-1">
          <span className="w-3 h-3 rounded-sm bg-green-500" />
          High (80%+)
        </span>
        <span className="flex items-center gap-1">
          <span className="w-3 h-3 rounded-sm bg-yellow-500" />
          Medium (60-79%)
        </span>
        <span className="flex items-center gap-1">
          <span className="w-3 h-3 rounded-sm bg-red-500" />
          Low (&lt;60%)
        </span>
      </div>
    </div>
  );
}
